import { Component, Inject, NgModule } from '@angular/core';
import { SiteTreetableService } from './site-treetable.service';
import { SiteBrowserState } from '../../core/util/site-browser.state';
import { NotificationService } from '../../core/util/notification.service';
import { CommonModule } from '@angular/common';
import { TreeTableModule } from 'primeng/components/treetable/treetable';
var SiteTreeTableComponent = (function () {
    function SiteTreeTableComponent(updateService, siteTreetableService, messageService) {
        var _this = this;
        this.updateService = updateService;
        this.siteTreetableService = siteTreetableService;
        this.messageService = messageService;
        this.dropzoneStylesVisible = true;
        this.site = updateService.getSelectedSite();
        if (updateService.getURI()) {
            this.loadFolder(updateService.getURI());
        }
        this.subscription = updateService.currentSite
            .subscribe(function (site) {
            if (site) {
                _this.loadHost(site);
            }
        });
        this.subscription = updateService.currentURI
            .subscribe(function (uri) {
            if (uri) {
                _this.loadFolder(uri);
            }
        });
        setTimeout(function () {
        }, 100);
    }
    /**
     * Deals with the style for the drag and drop of files
     * @param e
     */
    SiteTreeTableComponent.prototype.handleDragOver = function (e) {
        this.dropzoneStylesVisible = true;
    };
    /**
     * Handles uploading files on drag and drop
     * @param e
     */
    SiteTreeTableComponent.prototype.handleDrop = function (e) {
        e.preventDefault();
        var pathToUploadTo;
        var files = e.dataTransfer.files;
        var folderTitle = e.path[0].innerText;
        for (var i = 0; i < this.lazyFiles.length; i++) {
            var node = this.lazyFiles[i];
            if (node.data.title === folderTitle && node.data.type === 'folder') {
                pathToUploadTo = node.data.path;
                break;
            }
        }
        this.messageService.displayInfoMessage('Path is ' + pathToUploadTo);
        return;
    };
    /**
     * Loads the objects under a host
     * @param siteName
     */
    SiteTreeTableComponent.prototype.loadHost = function (site) {
        var _this = this;
        this.site = site;
        this.siteTreetableService.getAssetsUnderSite(site.hostname)
            .subscribe(function (items) { return _this.lazyFiles = items; });
        setTimeout(function () {
        }, 100);
    };
    /**
     * Loades the objects under a folder
     * @param uri
     */
    SiteTreeTableComponent.prototype.loadFolder = function (uri) {
        var _this = this;
        this.siteTreetableService.getAssetsUnderFolder(this.site.hostname, uri)
            .subscribe(function (items) { return _this.lazyFiles = items; });
        setTimeout(function () {
        }, 100);
    };
    /**
     * Handle clicking a node ie.. to show detail on a folder or file
     * @param event
     */
    SiteTreeTableComponent.prototype.nodeSelect = function (event) {
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Node Selected', detail: event.node.data.name });
    };
    /**
     * Unselects the selected node ie... file or folder
     * @param event
     */
    SiteTreeTableComponent.prototype.nodeUnselect = function (event) {
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Node Unselected', detail: event.node.data.name });
    };
    /**
     * Expands a node ie.. a folder
     * @param event
     */
    SiteTreeTableComponent.prototype.nodeExpand = function (event) {
        var _this = this;
        var pathName = event.node.data.path;
        pathName = pathName.slice(0, pathName.length - 1);
        pathName = pathName.slice(pathName.lastIndexOf('/') + 1, pathName.length);
        this.updateService.changeFolder(pathName);
        this.updateService.changeURI(event.node.data.path);
        if (event.node) {
            this.siteTreetableService.getAssetsUnderFolder(this.site.hostname, event.node.data.path)
                .subscribe(function (items) { return _this.lazyFiles = items; });
        }
        setTimeout(function () {
        }, 100);
    };
    return SiteTreeTableComponent;
}());
export { SiteTreeTableComponent };
SiteTreeTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'site-treetable',
                styles: [require('./../app.css')],
                template: "<div class=\"ContentSideSections Implementation\"\n                    (drop)=\"handleDrop($event, p-column)\" (dragover)=\"handleDragOver($event)\">\n        <p-treeTable [value]=\"lazyFiles\" [(selection)]=\"selectedNode\" [style]=\"&#123;'margin-top':'30px'&#125;\"\n                     (onNodeExpand)=\"nodeExpand($event)\" selectionMode=\"single\">\n            <p-column class=\"browser-dropzone\" field=\"title\" header=\"Name\"></p-column>\n            <p-column field=\"modDate\" header=\"Mod Date\" [style]=\"&#123;'width': '100px'&#125;\"></p-column>\n            <p-column field=\"type\" header=\"Type\" [style]=\"&#123;'width': '65px'&#125;\"></p-column>\n        </p-treeTable>\n    </div>"
            },] },
    { type: Inject, args: ['updateService',] },
];
/** @nocollapse */
SiteTreeTableComponent.ctorParameters = function () { return [
    { type: SiteBrowserState, },
    { type: SiteTreetableService, },
    { type: NotificationService, },
]; };
var DotSiteTreeTableModule = (function () {
    function DotSiteTreeTableModule() {
    }
    return DotSiteTreeTableModule;
}());
export { DotSiteTreeTableModule };
DotSiteTreeTableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SiteTreeTableComponent],
                exports: [SiteTreeTableComponent],
                imports: [CommonModule, TreeTableModule],
                providers: [SiteTreetableService, NotificationService]
            },] },
];
/** @nocollapse */
DotSiteTreeTableModule.ctorParameters = function () { return []; };
//# sourceMappingURL=site-treetable.component.js.map